import { Component, OnInit } from '@angular/core';
import { VideoService } from '../video.service';
import { TimedisplayPipe } from '../timedisplay.pipe';
import { EscapeHtmlPipe } from '../escape-html.pipe';

@Component({
  selector: 'video-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.css']
})
export class ToolbarComponent implements OnInit {
  isMobile:boolean = false;
  iosVersion:number = -1;
  constructor(private _videoService:VideoService){}

  ngOnInit() {
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ) {
      this.isMobile = true;
    }
    //window["alerty"]("Hello");

    this.iosVersion = window["iOSversion"]();

    //alert(this.iosVersion);
  }

}



// WEBPACK FOOTER //
// /Users/aubreyfletcher/Desktop/projects/node/node_projects/ng5/cashfletcher_videoPlayer/src/app/toolbar/toolbar.component.ts